export const ORGANIZATION_KEYS = Object.freeze({
  name: 'organization.name',
  businessType: 'organization.business_type',
  ownerName: 'organization.owner_name',
  logoUrl: 'organization.logo_url',
  phone: 'organization.phone',
  email: 'organization.email',
  website: 'organization.website',
  physicalAddress: 'organization.physical_address',
});

export const BUSINESS_TYPE_SLUGS = Object.freeze([
  'children_playhouse',
  'gym',
  'game_nets',
  'workspace',
  'boardgame_cafe',
]);
